var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#42A5F5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75.5,
    r: 75.5,
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.267 79.654c1.64-1.994 2.608-4.726 2.906-7.975.82-9.231-3.875-21.49-11.477-29.909-1.565-1.699-3.055-1.92-4.024-1.699-2.46.37-3.652 3.176-4.472 4.948-.074.222-.149.443-.298.591a8.604 8.604 0 0 0-1.938 1.773c-1.714 2.141-2.16 4.578-1.043 5.464 1.118.886 3.428-.147 5.142-2.289 1.118-1.33 1.64-2.88 1.64-3.988v-.074c.298-.59.969-2.141 1.49-2.584.075.073.299.221.448.443 6.856 7.532 11.253 18.831 10.508 26.954-.224 2.216-.895 5.096-2.981 6.868-2.236 1.551-5.217 1.477-7.453 1.108-7.974-1.403-17.886-8.493-23.55-16.911-.149-.296-.298-.443-.298-.591.596-.37 2.236-.665 2.907-.739h.074c1.118.296 2.683.148 4.323-.59 2.533-1.108 4.098-3.028 3.502-4.357-.596-1.33-3.13-1.477-5.59-.37-.893.37-1.639.887-2.235 1.404-.224 0-.373.073-.67.073-2.013.296-4.994.739-5.963 3.028-.372.886-.596 2.363.671 4.283 6.26 9.38 17.066 17.06 26.307 18.536 3.205.517 6.037.296 8.347-.738 3.801 6.277 5.888 16.025 4.546 21.268-.372 1.625-1.118 2.659-2.012 3.176-3.577 1.92-6.856-.665-11.477-4.8-3.204-2.88-6.185-5.539-9.688-5.539-3.652 0-7.9 2.142-12.073 4.21-3.95 1.993-8.869 4.504-10.88 3.323-.746-.444-1.864-1.92-1.938-7.09 3.279-.812 5.738-3.988 5.738-7.754 0-4.431-3.28-7.976-7.378-7.976-4.024 0-7.378 3.545-7.378 7.976 0 3.25 1.789 6.056 4.322 7.237 0 6.056 1.342 9.748 4.174 11.447 4.173 2.51 9.837-.37 15.352-3.102 3.652-1.846 7.378-3.692 9.912-3.692 1.714 0 4.173 2.215 6.558 4.357C88.746 108.38 92.771 112 97.391 112c1.49 0 3.056-.37 4.695-1.255 2.087-1.182 3.503-3.176 4.248-6.056 2.087-7.237-1.043-18.536-5.067-25.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymCheck);
export default __webpack_public_path__ + "static/media/sym-check.8596de3e184568395373e1d9f935c788.svg";
export { ForwardRef as ReactComponent };